<div id="startersDispensationInfo" class="ap-margin-1">
    <extra-information
        [textType]="textType.INFO"
        [tipContent]="
            'income.starters-dispensation.info' | startersDispensationInfoPipe: option : (store.getHasCoApplicant() | async) | apContent
        "
    ></extra-information>
</div>
@if ((store.isSummary() | async) === false) {
    <next-button (click)="nextQuestion()"></next-button>
}
